class Controller {
  constructor(Sections, Events) {
    "ngInject";

    this.addItemEvent = Events.getAddEvent("paymentMethods");
    this.paginateEvent = Events.getPaginateEvent("paymentMethods");
    this.sections = Sections.settingsSections;

    this.resourceParams = { isCityRequired: false };
  }

  addItemCustomizeOptions(model) {
    const {
      referenceName,
      referenceMinLength,
      referenceMaxLength,
      referenceType,
      referenceRequired = false,
    } = model;

    model.references = [
      {
        name: referenceName,
        min_length: referenceMinLength,
        max_length: referenceMaxLength,
        type: referenceType,
        required: referenceRequired,
      },
    ];

    [
      "referenceName",
      "referenceMinLength",
      "referenceMaxLength",
      "referenceType",
      "referenceRequired",
    ].forEach((key) => delete model[key]);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/paymentMethods/paymentMethods.controller.js